import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGeminiOmniAiVideoGeneratorConfig } from '@/data/landingConfig/landingGeminiOmniAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GeminiOmniAiVideoGenerator } from './schemaObject';

interface Props {}
const GeminiOmniAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GeminiOmniAiVideoGenerator} />
			<LandingTemplate
				data={landingGeminiOmniAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default GeminiOmniAiVideoGenerator;
